import type { ContentType } from '@/@types/common'
import type { Notification } from '@/@types/notification'
import LikeIcon from '@/assets/like.svg?react'
import ClickableStackAvatarGroup from '@/components/ClickableStackAvatarGroup'
import ScreenNames from '@/components/ScreenNames'
import { CONTENT_LOCALE } from '@/constants/locale'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './LikeNotification.module.css'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'

export interface LikeNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: Notification
	type: ContentType
}

export default function LikeNotification({
	data,
	type: contentType,
	className,
	...props
}: LikeNotificationProps) {
	const {
		actionItem: { users, usersCount },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<div className={styles.content}>
				<header className={styles.header}>
					<LikeIcon className={styles.icon} />
					<div className={styles.headerText}>
						<ScreenNames data={users.slice(0, 3)} />
						<span className={styles.secondaryText}>
							{usersCount > 3 && <span>等{usersCount}人</span>}
							赞了你的{CONTENT_LOCALE[contentType]}
						</span>
					</div>
				</header>

				<main>
					<ClickableStackAvatarGroup data={users} isMoreIconShow={usersCount > users.length} />
				</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
